(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feelings-timeline"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lx-journey')) {
    class LxJourney extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.lxj__track');
        this.stages = Array.from(this.querySelectorAll('.lxj__stage'));
        this.counted = new WeakSet();
        if (!this.track || !this.stages.length) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.style.setProperty('--p', 1);
          this.stages.forEach((st) => this.activate(st, true, true));
          return;
        }
        this.querySelectorAll('[data-lxj-count]').forEach((el) => (el.textContent = '0'));
        this.onScroll = () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.update());
        };
        this.mq = window.matchMedia('(min-width: 990px)');
        this.onMq = () => this.setup();
        this.mq.addEventListener?.('change', this.onMq);
        this.setup();
      }

      disconnectedCallback() {
        this.teardown();
        this.mq?.removeEventListener?.('change', this.onMq);
      }

      teardown() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        this.io?.disconnect();
        (this.timers || []).forEach(clearTimeout);
      }

      get horizontal() {
        return this.dataset.layout === 'cards' && this.mq.matches;
      }

      setup() {
        this.teardown();
        if (this.dataset.progress === 'scroll' && !this.horizontal) {
          this.classList.remove('is-playing');
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll);
          this.update();
        } else {
          this.io = new IntersectionObserver(
            (entries) => {
              if (entries.some((e) => e.isIntersecting)) {
                this.io.disconnect();
                this.play();
              }
            },
            { threshold: 0.25 }
          );
          this.io.observe(this.track);
        }
      }

      update() {
        const anchor = window.innerHeight * 0.62;
        let current = null;
        this.stages.forEach((st) => {
          const dot = st.querySelector('.lxj__dot').getBoundingClientRect();
          const on = dot.top + dot.height / 2 <= anchor;
          this.activate(st, on);
          if (on) current = st;
        });
        this.stages.forEach((st) => st.classList.toggle('is-current', st === current));
        const first = this.stages[0].querySelector('.lxj__dot').getBoundingClientRect();
        const last = this.stages[this.stages.length - 1].querySelector('.lxj__dot').getBoundingClientRect();
        const start = first.top + first.height / 2;
        const end = last.top + last.height / 2;
        const p = end > start ? (anchor - start) / (end - start) : anchor >= start ? 1 : 0;
        this.style.setProperty('--p', Math.min(1, Math.max(0, p)).toFixed(4));
      }

      play() {
        this.classList.add('is-playing');
        requestAnimationFrame(() => this.style.setProperty('--p', 1));
        const step = 450;
        this.timers = this.stages.map((st, i) =>
          setTimeout(() => {
            this.activate(st, true);
            this.stages.forEach((o) => o.classList.toggle('is-current', o === st));
          }, 250 + i * step)
        );
      }

      activate(st, on, instant) {
        st.classList.toggle('is-active', on);
        if (!on) return;
        const el = st.querySelector('[data-lxj-count]');
        if (!el || this.counted.has(el)) return;
        this.counted.add(el);
        const target = parseInt(el.dataset.lxjCount, 10) || 0;
        if (instant) {
          el.textContent = target;
          return;
        }
        const t0 = performance.now();
        const dur = 1300;
        const tick = (now) => {
          const k = Math.min(1, (now - t0) / dur);
          el.textContent = Math.round(target * (1 - Math.pow(1 - k, 3)));
          if (k < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      }
    }
    customElements.define('lx-journey', LxJourney);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["impact-title"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lx-impact')) {
    const easings = {
      linear: (t) => t,
      quad: (t) => t * (2 - t),
      expo: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
    };

    class LxImpact extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.lxi-anim'));
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
          this.items.forEach((el) => el.classList.add('is-visible'));
          return;
        }
        this.classList.add('lxi--js');
        const replay = this.dataset.replay === 'true';
        this.items.forEach((el) => {
          const count = el.querySelector('.lxi__count');
          if (count) count.textContent = this.format(count, parseFloat(count.dataset.start) || 0);
        });
        this.io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const el = entry.target;
              const count = el.querySelector('.lxi__count');
              if (entry.isIntersecting) {
                if (el.classList.contains('is-visible') && !(count && count.dataset.replay === 'true' && !el.dataset.counting)) return;
                el.classList.add('is-visible');
                if (count && (!el.dataset.counted || count.dataset.replay === 'true')) this.count(el, count);
                if (!replay && !(count && count.dataset.replay === 'true')) this.io.unobserve(el);
              } else if (entry.boundingClientRect.top > 0 || entry.boundingClientRect.bottom < 0) {
                if (replay) el.classList.remove('is-visible');
                if (count && (replay || count.dataset.replay === 'true') && !el.dataset.counting) {
                  delete el.dataset.counted;
                  count.textContent = this.format(count, parseFloat(count.dataset.start) || 0);
                }
              }
            });
          },
          { threshold: 0.3 }
        );
        this.items.forEach((el) => this.io.observe(el));
      }

      disconnectedCallback() {
        this.io?.disconnect();
      }

      decimals(count) {
        const d = (v) => ((v || '').split('.')[1] || '').length;
        return Math.max(d(count.dataset.start), d(count.dataset.end));
      }

      format(count, value) {
        const dec = this.decimals(count);
        let text = value.toFixed(dec);
        if (count.dataset.separator === 'true') {
          const [int, frac] = text.split('.');
          text = int.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + (frac ? '.' + frac : '');
        }
        return text;
      }

      count(el, count) {
        el.dataset.counted = 'true';
        el.dataset.counting = 'true';
        const start = parseFloat(count.dataset.start) || 0;
        const end = parseFloat(count.dataset.end) || 0;
        const duration = parseInt(count.dataset.duration, 10) || 1800;
        const ease = easings[count.dataset.easing] || easings.quad;
        const delay = (parseFloat(getComputedStyle(el).getPropertyValue('--lxi-adl')) || 0) * 1000;
        const run = () => {
          const t0 = performance.now();
          const tick = (now) => {
            const k = Math.min(1, (now - t0) / duration);
            count.textContent = this.format(count, start + (end - start) * ease(k));
            if (k < 1) requestAnimationFrame(tick);
            else delete el.dataset.counting;
          };
          requestAnimationFrame(tick);
        };
        delay ? setTimeout(run, delay) : run();
      }
    }
    customElements.define('lx-impact', LxImpact);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-explainer"] && !Shopify.designMode) return;
  try {
    
  if (!window.lxeScrollBound) {
    window.lxeScrollBound = true;
    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-lxe-scroll]');
      if (!link) return;
      const target = document.querySelector(
        '.leadform-container, [id^="MainProduct-"] product-form, product-form, .product-form'
      );
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const field = target.querySelector('input:not([type="hidden"]), select, textarea');
      if (field) setTimeout(() => field.focus({ preventScroll: true }), 700);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-callouts"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lx-callouts')) {
    const SVGNS = 'http://www.w3.org/2000/svg';
    const clamp = (v) => Math.max(0, Math.min(1, v));

    class LxCallouts extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('.lxc__grid');
        this.svg = this.querySelector('.lxc__svg');
        this.frame = this.querySelector('.lxc__frame');
        this.pin = this.querySelector('.lxc__pin');
        this.stage = this.querySelector('.lxc__stage');
        this.cta = this.querySelector('.lxc__cta');
        this.cards = Array.from(this.querySelectorAll('.lxc__card'));
        if (!this.grid || !this.cards.length) return;
        this.uid = Math.random().toString(36).slice(2, 8);
        this.mq = window.matchMedia('(min-width: 990px)');
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.classList.add('lxc--js');
        this.progress = 0;
        this.onScroll = () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.update());
        };
        this.onResize = () => {
          cancelAnimationFrame(this.rafLayout);
          this.rafLayout = requestAnimationFrame(() => {
            this.layout();
            this.update();
          });
        };
        this.ro = new ResizeObserver(this.onResize);
        this.ro.observe(this.grid);
        window.addEventListener('resize', this.onResize);
        this.layout();
        if (this.reduce) {
          this.done = true;
          this.render(1);
          return;
        }
        if (this.dataset.mode === 'once') {
          this.render(0);
          this.io = new IntersectionObserver(
            (entries) => {
              if (entries.some((e) => e.isIntersecting)) {
                this.io.disconnect();
                this.play();
              }
            },
            { threshold: 0.35 }
          );
          this.io.observe(this.grid);
        } else {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.update();
        }
      }

      disconnectedCallback() {
        this.ro?.disconnect();
        this.io?.disconnect();
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
      }

      get desktop() {
        return this.mq.matches;
      }

      /* Sticky "pinned" stage while the arrows draw (desktop, scroll mode) */
      setupPin() {
        this.pinned = false;
        this.pin.style.blockSize = '';
        this.stage.style.position = '';
        this.stage.style.insetBlockStart = '';
        if (this.dataset.mode !== 'scroll' || this.dataset.pin !== 'true' || !this.desktop) return;
        const vh = window.innerHeight;
        const stageH = this.stage.offsetHeight;
        if (!vh || stageH > vh * 0.96) return;
        this.pinLen = (vh * (parseInt(this.dataset.pinLength, 10) || 150)) / 100;
        this.pin.style.blockSize = `${stageH + this.pinLen}px`;
        this.stage.style.position = 'sticky';
        this.stickyTop = Math.max(0, (vh - stageH) / 2);
        this.stage.style.insetBlockStart = `${this.stickyTop}px`;
        this.pinned = true;
      }

      point(rect, base, x, y) {
        return { x: rect.left - base.left + rect.width * x, y: rect.top - base.top + rect.height * y };
      }

      layout() {
        this.setupPin();
        const base = this.grid.getBoundingClientRect();
        const rtl = getComputedStyle(this).direction === 'rtl';
        const media = this.frame.getBoundingClientRect();
        const curve = (parseInt(this.dataset.curve, 10) || 0) / 100;
        const headSize = parseInt(this.dataset.head, 10) || 12;
        const dots = this.dataset.dots === 'true';
        this.svg.setAttribute('viewBox', `0 0 ${base.width} ${base.height}`);
        this.svg.textContent = '';
        const defs = document.createElementNS(SVGNS, 'defs');
        this.svg.appendChild(defs);
        this.arrows = this.cards.map((card, i) => {
          const r = card.getBoundingClientRect();
          let o;
          let e;
          let sign;
          if (this.desktop) {
            let ox = (parseFloat(card.dataset.ox) || 50) / 100;
            if (rtl) ox = 1 - ox;
            const oy = (parseFloat(card.dataset.oy) || 45) / 100;
            o = this.point(media, base, ox, oy);
            const cardLeft = r.left + r.width / 2 < media.left + media.width / 2;
            e = cardLeft ? this.point(r, base, 1, 0.5) : this.point(r, base, 0, 0.5);
            e.x += cardLeft ? 16 : -16;
            sign = cardLeft ? 1 : -1;
          } else {
            const prev = i === 0 ? media : this.cards[i - 1].getBoundingClientRect();
            o = this.point(prev, base, 0.5, 1);
            o.y += 8;
            e = this.point(r, base, 0.5, 0);
            e.y -= 14;
            sign = e.x > o.x ? -1 : 1;
          }
          const dx = e.x - o.x;
          const dy = e.y - o.y;
          const len = Math.hypot(dx, dy) || 1;
          const c = { x: (o.x + e.x) / 2 + (-dy / len) * len * curve * sign, y: (o.y + e.y) / 2 + (dx / len) * len * curve * sign };
          if (this.desktop && c.y > (o.y + e.y) / 2) {
            c.x = (o.x + e.x) / 2 + (dy / len) * len * curve * sign;
            c.y = (o.y + e.y) / 2 - (dx / len) * len * curve * sign;
          }
          const d = `M${o.x.toFixed(1)},${o.y.toFixed(1)} Q${c.x.toFixed(1)},${c.y.toFixed(1)} ${e.x.toFixed(1)},${e.y.toFixed(1)}`;

          const maskId = `lxc-${this.uid}-${i}`;
          const mask = document.createElementNS(SVGNS, 'mask');
          mask.setAttribute('id', maskId);
          mask.setAttribute('maskUnits', 'userSpaceOnUse');
          const reveal = document.createElementNS(SVGNS, 'path');
          reveal.setAttribute('d', d);
          reveal.setAttribute('fill', 'none');
          reveal.setAttribute('stroke', '#fff');
          reveal.setAttribute('stroke-width', '14');
          reveal.setAttribute('stroke-linecap', 'round');
          mask.appendChild(reveal);
          defs.appendChild(mask);

          const halo = document.createElementNS(SVGNS, 'path');
          halo.setAttribute('d', d);
          halo.setAttribute('class', 'lxc__halo');
          halo.setAttribute('mask', `url(#${maskId})`);
          this.svg.appendChild(halo);

          const line = document.createElementNS(SVGNS, 'path');
          line.setAttribute('d', d);
          line.setAttribute('class', 'lxc__line');
          line.setAttribute('mask', `url(#${maskId})`);
          this.svg.appendChild(line);

          const tx = e.x - c.x;
          const ty = e.y - c.y;
          const tl = Math.hypot(tx, ty) || 1;
          const ux = tx / tl;
          const uy = ty / tl;
          const wing = (angle) => {
            const cos = Math.cos(angle);
            const sin = Math.sin(angle);
            return `${(e.x - headSize * (ux * cos - uy * sin)).toFixed(1)},${(e.y - headSize * (ux * sin + uy * cos)).toFixed(1)}`;
          };
          const head = document.createElementNS(SVGNS, 'path');
          head.setAttribute('d', `M${wing(0.5)} L${e.x.toFixed(1)},${e.y.toFixed(1)} L${wing(-0.5)}`);
          head.setAttribute('class', 'lxc__head');
          const headHalo = head.cloneNode();
          headHalo.setAttribute('class', 'lxc__head lxc__head--halo');
          this.svg.appendChild(headHalo);
          this.svg.appendChild(head);

          let dot = null;
          let ring = null;
          if (dots && (this.desktop || i === 0)) {
            ring = document.createElementNS(SVGNS, 'circle');
            ring.setAttribute('class', 'lxc__ring');
            ring.setAttribute('cx', o.x);
            ring.setAttribute('cy', o.y);
            ring.setAttribute('r', 5);
            this.svg.appendChild(ring);
            dot = document.createElementNS(SVGNS, 'circle');
            dot.setAttribute('class', 'lxc__dot');
            dot.setAttribute('cx', o.x);
            dot.setAttribute('cy', o.y);
            dot.setAttribute('r', 5);
            this.svg.appendChild(dot);
          }
          const total = reveal.getTotalLength();
          reveal.style.strokeDasharray = `${total} ${total}`;
          return { card, reveal, head, headHalo, dot, ring, total };
        });
        this.render(this.done ? 1 : this.progress);
      }

      /* Scroll mode: progress from the pinned stage, or from each card position when not pinned */
      update() {
        if (this.dataset.mode === 'once' || this.reduce) return;
        if (this.pinned) {
          const top = this.pin.getBoundingClientRect().top;
          this.render(clamp((this.stickyTop - top) / this.pinLen));
          return;
        }
        const vh = window.innerHeight || 800;
        const values = this.cards.map((card) => clamp((vh * 0.92 - card.getBoundingClientRect().top) / (vh * 0.3)));
        this.renderEach(values);
      }

      render(p) {
        this.progress = p;
        const n = this.arrows.length;
        const seg = 1 / n;
        this.renderEach(this.arrows.map((_, i) => clamp((p - i * seg) / (seg * 0.8))));
      }

      renderEach(values) {
        values.forEach((a, i) => {
          const arrow = this.arrows[i];
          if (!arrow) return;
          arrow.reveal.style.strokeDashoffset = (arrow.total * (1 - a)).toFixed(1);
          arrow.head.classList.toggle('is-on', a > 0.97);
          arrow.headHalo.classList.toggle('is-on', a > 0.97);
          arrow.dot?.classList.toggle('is-on', a > 0);
          arrow.ring?.classList.toggle('is-on', a > 0);
          arrow.card.classList.toggle('is-on', a > 0.97);
        });
        this.cta?.classList.toggle('is-on', values[values.length - 1] > 0.97);
      }

      play() {
        const per = parseInt(this.dataset.speed, 10) || 900;
        const total = per * this.arrows.length;
        const t0 = performance.now();
        const tick = (now) => {
          const p = clamp((now - t0) / total);
          this.render(p);
          if (p < 1) requestAnimationFrame(tick);
          else this.done = true;
        };
        requestAnimationFrame(tick);
      }
    }
    customElements.define('lx-callouts', LxCallouts);
  }

  if (!window.lxcScrollBound) {
    window.lxcScrollBound = true;
    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-lxc-scroll]');
      if (!link) return;
      const target = document.querySelector('.leadform-container, [id^="MainProduct-"] product-form, product-form, .product-form');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const field = target.querySelector('input:not([type="hidden"]), select, textarea');
      if (field) setTimeout(() => field.focus({ preventScroll: true }), 700);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
